import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./../styles/App.css";
import { Link } from "react-router-dom";


export default function SubHeader() {
  return (
    <div className="subheader d-flex align-items-center justify-content-between px-5 ">
      {/* Contact Info */}
      <div className="d-flex align-items-center">
        <i className="fa fa-phone me-2 text-danger"></i>
        <span className="me-4">+257 22 27 62 29</span>

        <i className="fa fa-envelope me-2 text-danger"></i>
        <span>onpr_burundi@onpr.bi</span>
      </div>

      {/* Button */}
      <Link to='/login'> <button className="btn btn-danger px-4">Se Connecter</button></Link>
    </div>
  );
}
